import React from 'react';
import './games-played-tracker.css';
import { days } from '../../../helpers/time';
import { Icon } from '../../../components/icon';
import { Paragraph } from '../../../components/paragraph';

const GamesPlayedTracker = props => {
    const { gamesPlayed } = props;

    return (
        <div className="games-played-tracker" role="table">
            {Object.keys(gamesPlayed).map(day => {
                const amountOfPlaceholdersNeeded = 6 - gamesPlayed[day].length;
                return (
                    <div
                        className="games-played-tracker__day"
                        key={'day' + day}
                        role="row"
                    >
                        <div className="games-played-tracker__day-text">
                            <Paragraph
                                colorScheme="dark"
                                withSpacing={false}
                                size="small"
                            >
                                {days[day]}
                            </Paragraph>
                        </div>
                        <div className="games-played-tracker__day-games">
                            {gamesPlayed[day].map((game, i) => (
                                <div
                                    className="games-played-tracker__game-icon"
                                    key={i + game}
                                    role="cell"
                                    aria-label={game}
                                >
                                    <Icon iconName={game} colorScheme="dark" />
                                </div>
                            ))}
                            {amountOfPlaceholdersNeeded > 0 &&
                                Array.from(
                                    Array(amountOfPlaceholdersNeeded),
                                    (iconPlaceholder, i) => (
                                        <div
                                            className="games-played-tracker__game-icon"
                                            key={i}
                                            role="cell"
                                            aria-label="game played placeholder"
                                        />
                                    ),
                                )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export { GamesPlayedTracker };
